if (!customElements.get('sr-collection-directory')) {
  customElements.define(
    'sr-collection-directory',
    class SrCollectionDirectory extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('[data-sr-directory-search]');
        this.cards = Array.from(this.querySelectorAll('[data-sr-directory-card]'));
        this.groups = Array.from(this.querySelectorAll('[data-sr-directory-group]'));
        this.status = this.querySelector('[data-sr-directory-status]');
        this.empty = this.querySelector('[data-sr-directory-empty]');
        this.resultSingular = this.dataset.srDirectorySingular || 'category';
        this.resultPlural = this.dataset.srDirectoryPlural || 'categories';

        if (!this.input || this.cards.length === 0) return;

        this.input.addEventListener('input', () => this.filter());
        this.filter();
      }

      normalize(value) {
        return value
          .toLocaleLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .trim();
      }

      filter() {
        const query = this.normalize(this.input.value);
        let visibleCount = 0;

        this.cards.forEach((card) => {
          const matches = !query || this.normalize(card.dataset.srDirectoryKeywords || '').includes(query);
          card.hidden = !matches;
          if (matches) visibleCount += 1;
        });

        this.groups.forEach((group) => {
          group.hidden = !group.querySelector('[data-sr-directory-card]:not([hidden])');
        });

        if (this.status) {
          const label = visibleCount === 1 ? this.resultSingular : this.resultPlural;
          this.status.textContent = `Showing ${visibleCount} ${label}`;
        }

        if (this.empty) this.empty.hidden = visibleCount !== 0;
      }
    }
  );
}
